import { Collapse, Grid, IconButton, InputAdornment, Link, Paper, Skeleton, TextField, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { Box, Container } from "@mui/system";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import he from 'he';
import CloseIcon from '@mui/icons-material/Close';

function SearchBar({ searchClicked }){

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

    const [expanded, setExpanded]=useState(searchClicked);

    const [fetching,setFetching]=useState(false);
    const [showSearch,setShowSearch]=useState(false);
    const [results,setResults]=useState();

    useEffect(()=>{
        if(searchClicked){
            setExpanded(true);
        }
        else{
            if(showSearch){
                setShowSearch(false);
                setTimeout(()=>setExpanded(false), 300);
                document.getElementById('search-field').value='';
            }
            else{
                setExpanded(false);
            }
        }
    },[searchClicked]);

    //Delays the axios requests
    function debounce(func, delay){
        let timeoutId;
        return function (...args){
            clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                func(...args);
            }, delay);
        };
    }

    //Handle the axios requests
    const delayedHandleChange=debounce((input)=>{
        if(input!==''){
            setFetching(true);
            setShowSearch(true);
            const promises=[
                axios.get(WP_API_Settings.endpoint+'s2/v1/get_search_results',{
                    params:{
                        keyword:input
                    }
                }),
                        ];
            Promise.all(promises).then((response)=>{
                //console.log(response)
                setResults(
                    [
                        {
                            name:'Results',
                            results:response[0].data
                        },
                    ]
                );
                setFetching(false);
            });
        } 
        else{
            setShowSearch(false);
        }
    }, 300);

    //console.log(results)

    //Handle text input change
    function handleChange(e){
        const input=e.target.value;
        delayedHandleChange(input);
    }

    function reset(){
        setShowSearch(false);
        document.getElementById('search-field').value='';
    }

    return(
        <Box
            sx={{
                position:{
                    xs:'fixed',
                    md:'relative'
                },
                left:0,
                m:{
                    xs:'80px 0 0 0',
                    md:'-4px 1rem 0 0'
                },
                background:'white',
                opacity: mobile? expanded? 1 : 0 : 1,
                transition:'opacity 0.1s',
                //pointerEvents: mobile? expanded? 'initial' : 'none' : 'initial',
                width:{
                    xs:'100vw',
                    md:'auto'
                },
                height:{
                    xs: mobile? expanded? window.innerHeight-100+'px' : 0 : 'auto',
                    md:'auto'
                },
                p:{
                    xs: mobile? expanded? '1rem' : '0' : '1rem',
                    md:0
                },
                overflow:{
                    xs:'scroll',
                    md:'initial'
                },
                zIndex: 1000
            }}
        >
            <Collapse in={mobile? true : expanded} orientation="horizontal">
                <TextField
                    onChange={e=>handleChange(e)}
                    placeholder="Search"
                    InputProps={{
                        id:'search-field',
                        startAdornment:
                        <InputAdornment position="start">
                            <SearchIcon/>
                        </InputAdornment>,
                        endAdornment:
                        <InputAdornment position="end">
                            <IconButton
                                onClick={reset}
                                sx={{
                                    color:'#000'
                                }}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </InputAdornment>
                    }}
                    sx={{
                        width:{
                            xs:'calc(100vw - 2rem)',
                            md:'350px'
                        }
                    }}
                />
            </Collapse>
            <Collapse in={showSearch}
                sx={{
                    position:'absolute',
                }}
            >
                <Container
                    sx={{
                        width:{
                            xs:'calc(100vw - 2rem)',
                            md:'350px'
                        },
                        maxHeight:{
                            xs:'none',
                            md: '50vh'
                        },
                        overflow:'scroll',
                        paddingLeft: '0!important',
                        paddingRight: '0!important',
                        border: mobile? 'none' : '1px solid #A3A3A3',
                        borderTop: '0',
                        borderRadius: '0 0 10px 10px',
                    }}
                >
                    <Paper
                        elevation={!mobile && 0}
                        sx={{
                            position:'relative',
                            mt:0,
                            p:{
                                xs:'2rem 0',
                                md:'2rem'
                            },
                            color:theme=>theme.palette.greyDark
                        }}
                    >
                        <Grid container spacing={6} direction={ mobile? 'column-reverse' : 'row' }>
                            <Grid item xs={12} md={12}>
                                {results && results.map((type)=>{
                                    // console.log(type)
                                    return(
                                        <Box
                                            sx={{
                                                mb:'1rem'
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display:'flex',
                                                    flexDirection:'column'
                                                }}
                                            >
                                                {fetching?
                                                    Array(3).fill(0).map(()=>{
                                                        return(
                                                            <Skeleton/>
                                                        );
                                                    })
                                                :
                                                    type.results.length?
                                                        Object.values(type.results).map((result)=>{
                                                            //console.log(result)
                                                            return(
                                                                <Box
                                                                    sx={{
                                                                        mb:'1rem',
                                                                        display:'flex',
                                                                        flexDirection:'column'
                                                                    }}
                                                                >
                                                                    <Link
                                                                        component={RouterLink}
                                                                        to={result.link}
                                                                        onClick={reset}
                                                                        sx={{
                                                                            m:'0.25rem 0',
                                                                            color: '#19314A',
                                                                            fontWeight: 'bold',
                                                                        }}
                                                                        dangerouslySetInnerHTML={{ __html: result?.title?.rendered || result?.title }}

                                                                    >
                                                                        {/* {he.decode(result.title?.rendered)} */}
                                                                    </Link>
                                                                    <Typography 
                                                                        variant='p'
                                                                        sx={{
                                                                            color: '#939393',
                                                                            fontSize: '0.8rem',
                                                                            textTransform: 'capitalize',
                                                                        }}
                                                                    >
                                                                        {result.type === 'theme_consulting' ? 'Consultancy Services' : result.type === 'theme_riskwisemodule' ? 'RiskWise Module' : result.type}
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant='p'
                                                                        sx={{
                                                                            color: '#19314A',
                                                                            fontSize: '0.9rem',
                                                                        }}
                                                                    >
                                                                        {result?.excerpt?.rendered ? he.decode(result.excerpt?.rendered) : result?.excerpt ? he.decode(result.excerpt) : ''}
                                                                    </Typography>
                                                                </Box>
                                                            );
                                                        })
                                                    :
                                                        <Typography>
                                                            {'No '+type.name+' found'}
                                                        </Typography>
                                                }
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </Paper>
                </Container>
            </Collapse>
        </Box>
    );
}

export default SearchBar;